// src/hooks/useReservation.js
import { useState } from "react";

export const useReservation = ({ actualYear, actualMonth, setFormPage , setAvailableHours }) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [choosedStartHour, setChoosedStartHour] = useState(null);
  const [choosedEndHour, setChoosedEndHour] = useState(null);

  const APIurl = "https://koparkoladowarka-99ee7a3b3d34.herokuapp.com";


  const checkDayAvailable = async (date) => {
    try {
      const response = await fetch(`${APIurl}/api/check-date?date=${date}`);
      const {available} = await response.json();
      setFormPage(1);
      return available;
    } catch (err) {
      throw err
    }
  };

  const handleDayClick = async (day) => {
    setSelectedDay(day);
    const selectedDate = new Date(actualYear, actualMonth, day);
    setSelectedDate(selectedDate);
    const availableHours = await checkDayAvailable(selectedDate);
    setAvailableHours(availableHours);
  };

  return {
    selectedDay,
    setSelectedDay,
    choosedStartHour,
    setChoosedStartHour,
    choosedEndHour,
    setChoosedEndHour,
    checkDayAvailable,
    handleDayClick,
    selectedDate
  };
};